import { render, staticRenderFns, recyclableRender, components } from "./article-details.vue?vue&type=template&id=44e262b1&scoped=true&"
var renderjs
import script from "./article-details.vue?vue&type=script&lang=js&"
export * from "./article-details.vue?vue&type=script&lang=js&"
import style0 from "./article-details.vue?vue&type=style&index=0&id=44e262b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e262b1",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/article-details/article-details.vue"
export default component.exports